import React, { useEffect, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DecryptFunction } from '../../utils/cryptoFunction';
import { useDispatch, useSelector } from 'react-redux';
import usersActions from '../../redux/users/actions';
import { AlphabetsValidation, InputTrimAndLowercaseFunction, MobileNumberFirstNumberValidation, MobileNumberValidation, handleEmailValidation } from '../../utils/validation';
import { Autocomplete, FormControl, Grid, TextField } from "@mui/material";
import Cookies from 'js-cookie';
import MauvelousPrimaryButton from '../../common/button/mauvelousPrimaryButton';
import BackButton from "../../common/button/backButton";
import masterActions from '../../redux/master/actions';

export default function Index() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const user = searchParams.get('user');

  const { roleList, adminuserDetails } = useSelector(state => state.usersReducer);
  const filteredroleList = roleList?.all?.filter((item)=>item?.rolename != "Objection Coordinator")

  const { backofficeTokenDetails } = useSelector(state => state.authReducer);

  const { buttonLoader } = useSelector(state => state.commonReducer);

  const [open, setOpen] = useState(false);
  const { courseList } = useSelector((state) => state.masterReducer);
  const filteredCourseList = courseList?.all?.filter((item)=>item?.isactive == 1)

  const prevCourses = adminuserDetails?.courses?.split(',')?.map(Number);


  const { register, handleSubmit, formState: { errors }, control, reset,getValues,watch } = useForm();
  const [selectedRoles, setSelectedRoles] = useState([]); // New state to track selected roles
  useEffect(() => {
    if (DecryptFunction(user)) {
      dispatch({ type: usersActions.GET_ADMINUSER_DETAILS, payload: DecryptFunction(user) });
    } else {
      navigate(`/${Cookies.get('mhet_mst_project')}/users`);
    };
    //eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    dispatch({ type: usersActions.GET_ROLE_LIST });
    dispatch({ type: masterActions.GET_COURSE_LIST }); // Fetch courses

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (filteredroleList.length > 0) {
      let roleids = adminuserDetails?.roleids?.split(','), role = [];
      for (let i = 0; i < roleids?.length; i++) {
        role.push(filteredroleList.find(val => val?.roleid === parseInt(roleids[i]))?.rolename);
      };
      // reset({
      //   ...adminuserDetails,
      //   role: role
      // });

      let prevSelectedCourses = prevCourses?.map(courseId => 
        filteredCourseList.find(course => course.courseid === courseId)?.coursename
      ).filter(Boolean); // Ensures no undefined values

      reset({
        ...adminuserDetails,
        role: role,
        courseList: prevSelectedCourses // Setting default values for courseList
      });
    }
    //eslint-disable-next-line
  }, [adminuserDetails, roleList?.filtered]);

  const onSubmit = (data) => {
    let ids = data['role']?.map((val) => {
      return filteredroleList.find((r) => r?.rolename === val)?.roleid
    });
    let oldarr = adminuserDetails?.roleids?.split(',')?.map(role => parseInt(role));
    let deletedids = [], newids = [];
    deletedids = oldarr.filter(item => !ids.includes(item));
    newids = ids.filter(item => !oldarr.includes(item));
    
    data['role'] = newids?.length > 0 ? newids?.join(",") : "";
    data['deletedrole'] = deletedids?.length > 0 ? deletedids?.join(",") : "";
    data['createdby'] = parseInt(backofficeTokenDetails?.id);
    data['status'] = parseInt(data?.status);
    data['userid'] = parseInt(data?.userid);
    delete data['roleids'];
    delete data['rolenames'];

    let courses = data['courseList']?.map((val) => {
      return filteredCourseList.find((c) => c?.coursename == val).courseid
  });



    data['courseList'] = courses?.join(",");


    dispatch({
      type: usersActions.UPDATE_ADMINUSER,
      payload: { id: DecryptFunction(user), data: data, navigate: navigate }
    });
  };
  const handleRoleChange = (newRoles) => {
    setSelectedRoles(newRoles); // Update the selected roles
  };

  const handleBack = () => {
    navigate(`/${Cookies.get('mhet_mst_project')}/users`);
  };

  return (
    <Grid
      style={{
        padding: "24px",
        // minHeight: "60vh",
        backgroundColor: "#fff",
        borderRadius: "8px",
        marginTop: '12px'
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label={
              <span>
                Name
                <span className="error" style={{ color: "red" }}>
                  {" "}
                  *
                </span>
              </span>
            }
            placeholder="Enter name"
            {...register("fullname", {
              required: "Name is required",
              pattern: {
                value: /^[a-zA-Z ]*$/,
                message: "Name should only contain alphabets",
              }
            })}
            onInput={AlphabetsValidation}
            error={!!errors.fullname}
            helperText={errors.fullname?.message}
            InputLabelProps={{ shrink: true }}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="tel"
            inputProps={{ maxLength: 10 }}
            label={
              <span>
                Mobile No
                <span className="error" style={{ color: "red" }}>
                  {" "}
                  *
                </span>
              </span>
            }
            placeholder="Enter mobile number"
            {...register("mobileno", {
              required: "Mobile no is required",
              minLength: {
                value: 10,
                message: "Enter valid mobile number",
              },
              validate: MobileNumberFirstNumberValidation
            })}
            onInput={MobileNumberValidation}
            error={!!errors.mobileno}
            helperText={errors.mobileno?.message}
            InputLabelProps={{ shrink: true }}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="text"
            label={
              <span>
                Email ID
                <span className="error" style={{ color: "red" }}>
                  {" "}
                  *
                </span>
              </span>
            }
            placeholder="Enter email id"
            {...register("emailid", {
              required: "Email id is required",
              validate: handleEmailValidation
            })}
            onInput={InputTrimAndLowercaseFunction}
            error={!!errors.emailid}
            helperText={errors.emailid?.message}
            InputLabelProps={{ shrink: true }}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <FormControl fullWidth>
            <Controller
              name="role"
              control={control}
              defaultValue={[]}
              rules={{ required: 'Module is required' }}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  multiple
                  size="small"
                  options={filteredroleList?.map(suggestion => suggestion.rolename)}
                  onChange={(_, newValue) => {
                    field.onChange(newValue);
                    handleRoleChange(newValue);
                  }}
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      multiline
                      label={
                        <span>
                          Module
                          <span className="error" style={{ color: "red" }}>
                            {" "}
                            *
                          </span>
                        </span>
                      }
                      sx={{ width: '100%' }}
                      error={!!errors.role}
                      helperText={errors.role?.message}
                      FormHelperTextProps={{
                        style: { margin: 0 },
                      }}
                    />
                  )}
                />
              )}
            />
          </FormControl>
        </Grid>



 
        {Array.isArray(watch('role')) && watch('role').includes('Objection Reviewer')  && (
          <Grid item xs={12} md={6} xl={6}>
            <FormControl fullWidth>
              <Controller
                name="courseList"
                control={control}
                // defaultValue={[prevCourses?prevCourses : null]}
                defaultValue={prevCourses || []}

                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    multiple
                    size="small"
                    // options={filteredCourseList.map(c => c.coursename) || []}
                    // options={filteredroleList ? filteredroleList.map(suggestion => suggestion.rolename) : []}
                    options={filteredCourseList ? filteredCourseList.map(c => c.coursename) : []}

                    onChange={(_, newValue) => field.onChange(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Courses"
                        error={!!errors.courseList}
                        helperText={errors.courseList?.message}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}
        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '24px' }}>
          <BackButton handleBack={handleBack} />
          <MauvelousPrimaryButton title={buttonLoader ? "loader" : "Submit"} handleClick={handleSubmit(onSubmit)} />
        </Grid>
      </Grid>
    </Grid>
  )
}
